module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAXCAYAAADk3wSdAAAAz0lEQVR42mLU2WvGgAP8Z8APPgKxADYJJgYagFFDRw0dsYayQOk2IHYjUS8PEJ9BE9sAxC2M0LwvDMSngFiJAgdeB2ILIP4E8/5bIA4E4m9kGvgRqv8TepheAuJEIkonbKVZLBDfxBVRq4C4m0RDm4B4M6HYrwLiXUQaCDKskZgk9ReII4H4LgEDb0G9/Z/YdPqOQMSBIiQAGkEkJf7LQJyAxSX/oRF6ndwctRqIu9DEWoB4HaXZtBqId0LZ27FFDDmGwiJuB5T+S0gDQIABACe7LVcly89NAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/greendown.png
// module id = c28w
// module chunks = 1